// extracted by mini-css-extract-plugin
export default {"container":"CustomerCreatedScreen_container__8l37d","text":"CustomerCreatedScreen_text__-9Vce","check":"CustomerCreatedScreen_check__ADs3N"};